import { agents as actionTypes } from '$constants/action-types';

export const update = params => ({
  type: actionTypes.UPDATE,
  params
});

export const updateRequest = () => ({
  type: actionTypes.UPDATE_REQUEST
});

export const updateSuccess = (info, result) => ({
  type: actionTypes.UPDATE_SUCCESS,
  info,
  result
});

export const updateFailure = errors => ({
  type: actionTypes.UPDATE_FAILURE,
  errors
});

export const fetchCurrent = () => ({
  type: actionTypes.FETCH_CURRENT
});

export const fetchCurrentRequest = () => ({
  type: actionTypes.FETCH_CURRENT_REQUEST
});

export const fetchCurrentSuccess = result => ({
  type: actionTypes.FETCH_CURRENT_SUCCESS,
  result
});



// WEBPACK FOOTER //
// ./src/actions/agents.js